import { render, staticRenderFns } from "./detail-partial-professional-kitchen.vue?vue&type=template&id=346ae9fc"
import script from "./detail-partial-professional-kitchen.vue?vue&type=script&lang=js"
export * from "./detail-partial-professional-kitchen.vue?vue&type=script&lang=js"
import style0 from "./detail-partial-professional-kitchen.vue?vue&type=style&index=0&id=346ae9fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports